import { Component, Input } from '@angular/core';

/**ToDo Documentazione */
@Component({
  selector: 'app-recap-hotels',
  styleUrls: ['./recap-hotels.component.scss'],
  templateUrl: './recap-hotels.component.html'
})
export class RecapHotelsComponent {
  @Input() public day: any;
  @Input() public serviceIcons: any;

  public getServiceIconPath(name: string): string | undefined {
    return this.serviceIcons ? this.serviceIcons[name] : undefined;
  }
}
